import { Box } from "@mui/material";

export const FlexBox = ({ className = "", ...props }) => {
  return <Box className={`FlexBox ${className}`} {...props} />;
};
